/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './main-navigation.ngfactory';
import * as i2 from '../../../app/components/main-navigation';
import * as i3 from 'angular2-token';
import * as i4 from '@angular/router';
import * as i5 from '../../../app/components/main';
const styles_MainComponent:any[] = ([] as any[]);
export const RenderType_MainComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_MainComponent,data:{}});
export function View_MainComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'main']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),6,'div',[['class','m__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),2,'div',[['class','m__menu']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),1,'main-navigation',([] as any[]),
          (null as any),(null as any),(null as any),i1.View_MainNavigationComponent_0,
          i1.RenderType_MainNavigationComponent)),i0.ɵdid(4,49152,(null as any),0,
          i2.MainNavigationComponent,[i3.Angular2TokenService,i4.Router],(null as any),
          (null as any)),(_l()(),i0.ɵeld(5,0,(null as any),(null as any),2,'div',[['class',
          'm__content']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(6,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(7,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i0.ViewContainerRef,i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,7,0);
  },(null as any));
}
export function View_MainComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'main',([] as any[]),
      (null as any),(null as any),(null as any),View_MainComponent_0,RenderType_MainComponent)),
      i0.ɵdid(1,114688,(null as any),0,i5.MainComponent,[i3.Angular2TokenService,i4.Router],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const MainComponentNgFactory:i0.ComponentFactory<i5.MainComponent> = i0.ɵccf('main',
    i5.MainComponent,View_MainComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tYWluLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tYWluLnRzIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL21haW4ucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL21haW4udHMuTWFpbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJtYWluXCI+PGRpdiBjbGFzcz1cIm1fX2NvbnRlbnQtd3JhcHBlclwiPjxkaXYgY2xhc3M9XCJtX19tZW51XCI+PG1haW4tbmF2aWdhdGlvbj48L21haW4tbmF2aWdhdGlvbj48L2Rpdj48ZGl2IGNsYXNzPVwibV9fY29udGVudFwiPjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD48L2Rpdj48L2Rpdj48L2Rpdj4iLCI8bWFpbj48L21haW4+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBa0I7VUFBQTtNQUFnQztVQUFBO01BQXFCO1VBQUE7K0NBQUEsVUFBQTtxQ0FBQTtVQUFBLGVBQXlDO1VBQUE7TUFBd0I7VUFBQTthQUFBOzBEQUFBO1VBQUE7SUFBQTs7OztvQkNBeEk7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/main.ngfactory.ts